import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";

export const WhatsappEnumServices = {
    fetchWhatsappEnumList: async(data)=>{
        console.log("filter Data",data);
        const queryParams = new URLSearchParams();
        
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.pageSize);
        queryParams.append('searchKey', data.filters.searchKey || '');
        queryParams.append('sortBy', data.filters.sortBy);
        
        console.log("queryParams",queryParams.toString());
        return await commonRequest("GET",  `${Helpers.URL()}/api/admin/notification/whatsapp?${queryParams.toString()}`,{}, Helpers.token());
    },
    
    addWhatsappEnum: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/notification`, data, Helpers.token());
    },
    
    updateWhatsappEnum: async(data, id)=>{
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/notification/modify-whatsapp-enum/${id}`, data, Helpers.token());
    },
}
